import React from 'react';
import { observer } from 'mobx-react';
import { isEqual } from 'lodash';
import { Link } from 'core';
import { useClientStore } from 'apps/hooks';

export type CreateByrProps = {
  className?: string;
  username?: string;
  prefix?: React.ReactNode;
};

export const CreateBy: React.FC<CreateByrProps> = observer(
  ({ prefix = 'By', username, className = '' }) => {
    const clientStore = useClientStore();
    const loggedInUsername = clientStore.profileResponse?.username;

    const isLoggedUser =
      loggedInUsername && username && isEqual(loggedInUsername, username);

    return (
      !!username && (
        <div className={className || 'flex items-center'}>
          {prefix}
          {isLoggedUser ? (
            <p className='mx-1'>you</p>
          ) : (
            <Link
              style={{
                pointerEvent: 'all',
              }}
              className=' hover:opacity-70 mx-1 '
              name='profile'
              openTab={{
                title: username,
              }}
              params={{ profile: username }}
            >
              {username}
            </Link>
          )}
        </div>
      )
    );
  },
);
